import React, { useState, useEffect } from "react";
import { useEditLock } from "../../context/EditLockContext";

const APP_ICON = `${process.env.PUBLIC_URL}/favicon_io/apple-touch-icon.png`;

export default function RotatingBrandLogo({ version }) {
  const [showText, setShowText] = useState(false);
  const { registerUnlockTap, canEdit } = useEditLock();

  useEffect(() => {
    const showForMs = 2600;
    let timeoutId = null;
    const intervalId = setInterval(() => {
      setShowText(true);
      timeoutId = window.setTimeout(() => setShowText(false), showForMs);
    }, 60000);
    return () => {
      clearInterval(intervalId);
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <button
      type="button"
      onClick={registerUnlockTap}
      style={styles.link}
      title={canEdit ? "Edición habilitada" : "Tocá 5 veces para escribir"}
      aria-label="App icon (unlock editing)"
    >
      <div style={styles.slot}>
        {showText ? (
          <span style={styles.wordmark}>trufitapp</span>
        ) : (
          <img src={APP_ICON} alt="TrufitApp" style={styles.avatar} />
        )}
      </div>
      <span style={styles.versionBadge}>v{version}</span>
    </button>
  );
}

const styles = {
  link: {
    appearance: "none",
    background: "transparent",
    border: "none",
    padding: 0,
    margin: 0,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
  slot: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.12)",
    transition: "opacity 0.4s ease",
  },
  avatar: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
  },
  wordmark: {
    color: "#fff",
    fontSize: "0.45rem",
    fontWeight: "800",
    letterSpacing: "0.5px",
    textTransform: "lowercase",
    textAlign: "center",
    lineHeight: 1.1,
    padding: "0 2px",
  },
  versionBadge: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "rgba(255,255,255,0.4)",
    padding: "2px 6px",
    borderRadius: "8px",
    fontSize: "0.5rem",
    fontWeight: "bold",
  },
};
